import * as React from 'react';
import { Button, Col, Collapse, Dropdown, Menu, Row, Space, Table, Tag, Tooltip } from 'antd';
import { useHistory } from 'react-router';
import { CompanyProductVersionModel, Feature } from '../../models/product-interface';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEllipsisV, faExclamationTriangle } from '@fortawesome/pro-regular-svg-icons';
import { IconProp } from '@fortawesome/fontawesome-svg-core';

const { Panel } = Collapse;

type Props = {
  product: CompanyProductVersionModel | undefined;
  demoFeatures: Feature[] | undefined;
  showSyncModal(productId: number): void;
  canUpdate: boolean;
};

const CompanyProductCard: React.FC<Props> = ({ product, demoFeatures, showSyncModal, canUpdate }) => {
  const history = useHistory();

  const columns: any = [
    {
      title: 'Feature Name',
      dataIndex: 'name',
      key: 'name',
      render: (_, record) => record.name,
    },
    {
      title: 'Record Limit',
      dataIndex: 'recordLimit',
      key: 'recordLimit',
      render: (_, record: Feature) =>
        record.recordLimit > 0 ? record.recordLimit : record.allowLimit ? "Unlimited" : "",
    },
  ];

  const features = (product == undefined ? demoFeatures : product.features) ?? []

  return (
    <Collapse bordered={false}>
      <Panel
        showArrow={features.length > 0}
        header={
          <Row>
            <Col span={24}>
              <span
                className='primary-text'
                style={{ cursor: 'pointer' }}
                onClick={(e) =>
                  history.push(`/admin/products/${!!product ? product.product.id : "demo"}`)
                }
              >
                {!!product ? product.product.name : "Demo Company"}
              </span>
            </Col>
            <Col>
              {features.length} feature
              {features.length !== 1 && 's'}
            </Col>
          </Row>
        }
        key={`product-${!!product ? product.product.id : "demo"}`}
        extra={
          <Space className='collapse-extra' onClick={(e) => e.stopPropagation()}>
            <Tag>{!!product ? product.product.category : "Demo Company"}</Tag>
            {!!product && <Tag>v{product.versionId}</Tag>}
            {!!product && product.newerVersions.length > 0 && (
              <Tooltip title='Newer version available'>
                <FontAwesomeIcon icon={faExclamationTriangle as IconProp} />
              </Tooltip>
            )}
              <Dropdown
                placement='bottomRight'
                overlay={
                  <Menu disabled={!product?.newerVersions?.length}>
                    <Menu.Item
                      id={`updateProductVersion-${product?.product.id}`}
                      key={`updateProductVersion-${product?.product.id}`}
                      onClick={() => showSyncModal(product?.product.id)}
                    >
                      {canUpdate ? "Update Product" : "Compare Product"}
                    </Menu.Item>
                  </Menu>
                }
              >
                <Tooltip overlay='Actions'>
                  <Button
                    id={`toolsButton-${product?.product.id}`}
                    aria-label='tools'
                    style={{ borderWidth: 0, backgroundColor: 'transparent' }}
                    icon={
                      <FontAwesomeIcon
                        aria-hidden='true'
                        icon={faEllipsisV as IconProp}
                      />
                    }
                  />
                </Tooltip>
              </Dropdown>
            
          </Space>
        }
      >
        <Table
          columns={columns}
          dataSource={features.map((x) => ({ ...x, key: x.id }))}
          pagination={false}
          size='small'
        />
      </Panel>
    </Collapse>
  );
};

export default CompanyProductCard;